module.exports = __webpack_public_path__ + "static/media/006.e7737c69.jpg";